import React from "react";
import { Image } from "react-bootstrap";

/**
 * Renders a sort icon based on the direction prop:
 * - "asc" for an ascending (up) arrow
 * - "desc" for a descending (down) arrow
 * - empty string or undefined for an unsorted icon
 * @param {Object} props
 * @param {string} props.direction - One of "asc", "desc", or empty string
 * @returns {ReactElement}
 */
const DataTableSortIcon = ({ direction }) => {
  let iconSrc = "/assets/images/Sort Icons.svg"; // default unsorted
  if (direction === "asc") iconSrc = "/assets/images/sort-up.svg";
  if (direction === "desc") iconSrc = "/assets/images/sort-down.svg";

  return (
    <Image
      src={iconSrc}
      className="ms-1"
      width={12}
      alt={direction || "unsorted"}
    />
  );
};

export default DataTableSortIcon;
